import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth } from '@/hooks/useAuth';
export function LanguageSwitcher() {
    const { user } = useAuth();
    const current = user?.language ?? 'en';
    const switchTo = async (lang) => {
        if (lang === current)
            return;
        await fetch('/api/auth/profile', {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ language: lang }),
        });
        window.location.reload();
    };
    return (_jsxs("div", { className: "flex gap-1 text-xs font-mono", children: [_jsx("button", { onClick: () => switchTo('en'), className: `px-1 ${current === 'en' ? 'text-warm-white' : 'text-stone-gray hover:text-warm-white'}`, children: "EN" }), _jsx("span", { className: "text-stone-gray", children: "/" }), _jsx("button", { onClick: () => switchTo('pl'), className: `px-1 ${current === 'pl' ? 'text-warm-white' : 'text-stone-gray hover:text-warm-white'}`, children: "PL" })] }));
}
